import types from "./types";

export default (
  state = {
    isFetchingList: false,
    facilities: [],
    facilitiesListError: "",
    isFetchingFacility: false,
    facilityCard: null,
    facilityCardError: "",
    isFetchingFullFacility: false,
    facilityFullInfo: null,
    facilityFullError: "",
    isCreatingFacility: false,
    createdFacility: null,
    facilityCreationError: "",
    isUpdatingFacility: false,
    updatedFacility: null,
    facilityUpdateError: "",
    isDeletingFacilities: false,
    deletedFacilities: null,
    deletingFacilitiesError: "",
    isFetchingOrganizations: false,
    organizations: [],
    organizationsError: "",
    isFetchingMunicipals: false,
    municipals: [],
    municipalsError: "",
    isFetchingDepartments: false,
    departments: [],
    departmentsError: "",
    isEditingDepartments: false,
    editedDepartments: null,
    departmentsEditError: "",
    images: null,
    imagesError: "",
    isDeletingImage: false,
    deletedImage: null,
    deletingImageError: "",
  },
  action
) => {
  switch (action.type) {
    case types.GET_FACILITIES_REQUEST:
      return {
        ...state,
        isFetchingList: action.isFetchingList
      };
    case types.GET_FACILITIES_COMPLETED:
      return {
        ...state,
        isFetchingList: action.isFetchingList,
        facilities: action.facilities
      };
    case types.GET_FACILITIES_ERROR:
      return {
        ...state,
        isFetching: action.isFetching,
        facilitiesError: action.facilitiesError
      };
    case types.GET_FACILITY_REQUEST:
      return {
        ...state,
        isFetchingFacility: action.isFetchingFacility
      };
    case types.GET_FACILITY_COMPLETED:
      return {
        ...state,
        isFetchingFacility: action.isFetchingFacility,
        facilityCard: action.facilityCard
      };
    case types.GET_FACILITY_ERROR:
      return {
        ...state,
        isFetchingFacility: action.isFetchingFacility,
        facilityCardError: action.facilityCardError
      };
    case types.GET_FULL_FACILITY_REQUEST:
      return {
        ...state,
        isFetchingFullFacility: action.isFetchingFullFacility
      };
    case types.GET_FULL_FACILITY_COMPLETED:
      return {
        ...state,
        isFetchingFullFacility: action.isFetchingFullFacility,
        facilityFullInfo: action.facilityFullInfo
      };
    case types.GET_FULL_FACILITY_ERROR:
      return {
        ...state,
        isFetchingFullFacility: action.isFetchingFullFacility,
        facilityFullError: action.facilityFullError
      };
    case types.CREATE_FACILITY_REQUEST:
      return {
        ...state,
        isCreatingFacility: action.isCreatingFacility
      };
    case types.CREATE_FACILITY_COMPLETED:
      return {
        ...state,
        isCreatingFacility: action.isCreatingFacility,
        createdFacility: action.createdFacility
      };
    case types.CREATE_FACILITY_ERROR:
      return {
        ...state,
        isCreatingFacility: action.isCreatingFacility,
        facilityCreationError: action.facilityCreationError
      };
    case types.UPDATE_FACILITY_REQUEST:
      return {
        ...state,
        isUpdatingFacility: action.isUpdatingFacility
      };
    case types.UPDATE_FACILITY_COMPLETED:
      return {
        ...state,
        isUpdatingFacility: action.isUpdatingFacility,
        updatedFacility: action.updatedFacility
      };
    case types.UPDATE_FACILITY_ERROR:
      return {
        ...state,
        isUpdatingFacility: action.isUpdatingFacility,
        facilityUpdateError: action.facilityUpdateError
      };
    case types.DELETE_FACILITIES_REQUEST:
      return {
        ...state,
        isDeletingFacilities: action.isDeletingFacilities
      };
    case types.DELETE_FACILITIES_COMPLETED:
      return {
        ...state,
        isDeletingFacilities: action.isDeletingFacilities,
        deletedFacilities: action.deletedFacilities
      };
    case types.DELETE_FACILITIES_ERROR:
      return {
        ...state,
        isDeletingFacilities: action.isDeletingFacilities,
        deletingFacilitiesError: action.deletingFacilitiesError
      };
    default:
      return state;
    case types.GET_ORGANIZATIONS_REQUEST:
      return {
        ...state,
        isFetchingOrganizations: action.isFetchingOrganizations
      };
    case types.GET_ORGANIZATIONS_COMPLETED:
      return {
        ...state,
        isFetchingOrganizations: action.isFetchingOrganizations,
        organizations: action.organizations
      };
    case types.GET_ORGANIZATIONS_ERROR:
      return {
        ...state,
        isFetchingOrganizations: action.isFetchingOrganizations,
        organizationsError: action.organizationsError
      };
    case types.GET_MUNICIPALS_REQUEST:
      return {
        ...state,
        isFetchingMunicipals: action.isFetchingMunicipals
      };
    case types.GET_MUNICIPALS_COMPLETED:
      return {
        ...state,
        isFetchingMunicipals: action.isFetchingMunicipals,
        municipals: action.municipals
      };
    case types.GET_MUNICIPALS_ERROR:
      return {
        ...state,
        isFetchingMunicipals: action.isFetchingMunicipals,
        municipalsError: action.municipalsError
      };
    case types.GET_DEPARTMENTS_REQUEST:
      return {
        ...state,
        isFetchingDepartments: action.isFetchingDepartments
      };
    case types.GET_DEPARTMENTS_COMPLETED:
      return {
        ...state,
        isFetchingDepartments: action.isFetchingDepartments,
        departments: action.departments
      };
    case types.GET_DEPARTMENTS_ERROR:
      return {
        ...state,
        isFetchingDepartments: action.isFetchingDepartments,
        departmentsError: action.departmentsError
      };
    case types.EDIT_DEPARTMENTS_REQUEST:
      return {
        ...state,
        isEditingDepartments: action.isEditingDepartments
      };
    case types.EDIT_DEPARTMENTS_COMPLETED:
      return {
        ...state,
        isAddingDepartments: action.isAddingDepartments,
        departmentsEdited: action.departmentsEdited
      };
    case types.EDIT_DEPARTMENTS_ERROR:
      return {
        ...state,
        isAddingDepartments: action.isAddingDepartments,
        departmentsEditError: action.departmentsEditError
      };
    case types.ADD_IMAGES_COMPLETED:
      return {
        ...state,
        images: action.images
      };
    case types.ADD_IMAGES_ERROR:
      return {
        ...state,
        imagesError: action.imagesError
      };
    case types.DELETE_IMAGE_REQUEST:
      return {
        ...state,
        isDeletingImage: action.isDeletingImage
      };
    case types.DELETE_IMAGE_COMPLETED:
      return {
        ...state,
        isDeletingImage: action.isDeletingImage,
        deletedImage: action.deletedImage
      };
    case types.DELETE_IMAGE_ERROR:
      return {
        ...state,
        isDeletingImage: action.deletedImage,
        deletingImageError: action.deletingImageError
      };
  }
};
